import { render, staticRenderFns } from "./SavedSearchNewMatchesSection.vue?vue&type=template&id=54ec22c4&scoped=true"
import script from "./SavedSearchNewMatchesSection.vue?vue&type=script&lang=js"
export * from "./SavedSearchNewMatchesSection.vue?vue&type=script&lang=js"
import style0 from "./SavedSearchNewMatchesSection.vue?vue&type=style&index=0&id=54ec22c4&prod&scoped=true&lang=css"
import style1 from "./SavedSearchNewMatchesSection.vue?vue&type=style&index=1&id=54ec22c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ec22c4",
  null
  
)

export default component.exports